<div class="modal-overlay" (click)="onClose()">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h3>Background settings</h3>
      <button class="close-btn" (click)="onClose()">×</button>
    </div>

    <div class="modal-body">
      <div class="flex-row" *ngIf="selectionInterval$ | async as interval">
        <div class="flex-row gap-4">
          <label>Start scene</label>
          <div>{{ interval[0] }}</div>
          <!-- 
          <select [ngModel]="startIndex" (ngModelChange)="onStartIndexChange($event)">
            <option *ngFor="let i of sceneIndexOptions" [ngValue]="i">{{ i }}</option>
          </select> 
          -->
        </div>
        <div class="flex-row gap-4">
          <label>End scene</label>
          <div>
            {{ interval[1] }}
          </div>
          <!-- <select
            [ngModel]="endIndex"
            (ngModelChange)="onEndIndexChange($event)"
          >
            <option *ngFor="let i of sceneIndexOptions" [ngValue]="i">
              {{ i }}
            </option>
          </select> -->
        </div>
      </div>

      <div class="row">
        <label>Type</label>
        <div class="type-selector">
          <div
            class="type-tile"
            [class.active]="type === 'glow'"
            (click)="onTypeChange('glow')"
          >
            <div class="preview glow"></div>
            <div class="label">Glow</div>
          </div>
          <div
            class="type-tile"
            [class.active]="type === 'gradient'"
            (click)="onTypeChange('gradient')"
          >
            <div class="preview gradient"></div>
            <div class="label">Gradient</div>
          </div>
          <div
            class="type-tile"
            [class.active]="type === 'static'"
            (click)="onTypeChange('static')"
          >
            <div class="preview stat"></div>
            <div class="label">Static color</div>
          </div>
          <div
            class="type-tile"
            [class.active]="type === 'image'"
            (click)="onTypeChange('image')"
          >
            <div class="preview image"></div>
            <div class="label">Image</div>
          </div>
          <div
            class="type-tile"
            [class.active]="type === 'video'"
            (click)="onTypeChange('video')"
          >
            <div class="preview video"></div>
            <div class="label">Video</div>
          </div>
        </div>
      </div>

      <div class="type-forms" [ngSwitch]="type">
        <!-- Glow form -->
        <div *ngSwitchCase="'glow'" class="form">
          <div class="form-row">
            <label>Glow color</label>
            <input type="color" [(ngModel)]="glowColor" />
          </div>
          <div class="form-row">
            <label>Intensity</label>
            <input type="range" min="0" max="100" [(ngModel)]="glowIntensity" />
            <span>{{ glowIntensity }}</span>
          </div>
        </div>

        <!-- Gradient form -->
        <div *ngSwitchCase="'gradient'" class="form">
          <div class="form-row">
            <label>Start</label>
            <input type="color" [(ngModel)]="gradientStart" />
          </div>
          <div class="form-row">
            <label>End</label>
            <input type="color" [(ngModel)]="gradientEnd" />
          </div>
          <div class="form-row">
            <label>Angle</label>
            <input type="range" min="0" max="360" [(ngModel)]="gradientAngle" />
            <span>{{ gradientAngle }}°</span>
          </div>
        </div>

        <!-- Static color form -->
        <div *ngSwitchCase="'static'" class="form">
          <div class="form-row">
            <label>Color</label>
            <input type="color" [(ngModel)]="staticColor" />
          </div>
        </div>

        <!-- Image form -->
        <div *ngSwitchCase="'image'" class="form">
          <div class="form-row">
            <label>Image URL</label>
            <input
              type="text"
              [(ngModel)]="imageUrl"
              placeholder="https://..."
            />
          </div>
        </div>

        <!-- Video form -->
        <div *ngSwitchCase="'video'" class="form">
          <div class="form-row">
            <label>Video URL</label>
            <input
              type="text"
              [(ngModel)]="videoUrl"
              placeholder="https://..."
            />
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button class="secondary" (click)="onClose()">Cancel</button>
        <button class="primary" (click)="onSave()">Save</button>
      </div>
    </div>
  </div>
</div>
